import { useLocation } from 'react-router-dom';
import dayjs from 'dayjs';
import { useUser } from 'modules/user/userSelector';
import useSubscriptionInfo from 'app/hooks/useSubscriptionInfo';
import routeConfig from 'app/config/routes';
import { isDevelopmentMode } from 'utils/helpers';

const NON_TRIAL_VISIBILITY_DAYS = 15;

interface OnboardingChecklistConfig {
  canShow: boolean;
  isTrial: boolean;
}

export const useOnboardingChecklistConfig = (): OnboardingChecklistConfig => {
  const user = useUser();
  const { isTrial } = useSubscriptionInfo();
  const location = useLocation();

  // [TEMPORARY] Dev environments have no Intercom app id, so /me/data returns a
  // null intercom payload and the owner check would always fail there.
  const isAdmin = user.role === 'admin';
  const isAccountOwner = isDevelopmentMode()
    ? isAdmin
    : isAdmin && !!user.intercom?.isAccountOwner;
  const isOnboardingRoute = location.pathname.startsWith(
    `/${routeConfig.onboarding.path}`,
  );

  const isWithinNonTrialWindow = (() => {
    if (!user.regDate) return false;
    const registeredAt = dayjs(user.regDate);
    if (!registeredAt.isValid()) return false;
    return dayjs().diff(registeredAt, 'day') <= NON_TRIAL_VISIBILITY_DAYS;
  })();

  const canShow =
    isAccountOwner && !isOnboardingRoute && (isTrial || isWithinNonTrialWindow);

  return { canShow, isTrial };
};
